import { toast } from "react-toastify";

const swal = async (type, text) => {
  // await Swal.fire({
  //   html: text,
  //   icon,
  //   confirmButtonText: "Ok, got it",
  //   allowOutsideClick: false,
  // }).then((r) => {
  //   if (callback === false) {
  //     callback();
  //   } else {
  //     if (callback !== undefined) {
  //       callback();
  //     }
  //   }
  //   if (is_reload) {
  //     window.location.reload();
  //   }
  // });
  switch (type) {
    case "success":
      toast.success(text);
      break;
    case "info":
      toast.info(text);
      break;
    default:
      toast.error(text);
      break;
  }
};

export default swal;
